// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__N4sns"};